var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _g, _g2, _path9, _rect3, _rect4, _rect5, _path10, _path11, _rect6, _rect7, _polygon, _path12, _path13, _path14, _polygon2, _path15, _path16, _polygon3, _path17, _path18, _path19, _polygon4, _polygon5, _path20, _path21, _rect8, _rect9, _polygon6, _polygon7, _path22, _path23, _path24, _path25, _path26, _polygon8, _polygon9, _path27, _path28, _g3, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _polygon10, _polygon11, _path51, _rect10, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _polygon12, _polygon13, _polygon14, _polygon15, _path69, _path70, _path71, _path72, _path73, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStuTeaLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u043B\\u043E\\u0439_1",
    "data-name": "\\u2018\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2745.48 1580.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1168.47,1610.32l-4.89-2.68a10.79,10.79,0,0,1-4.28-14.64l22.45-41a10.8,10.8,0,0,1,14.65-4.28l7,3.83a2.11,2.11,0,1,1-2,3.71l-7-3.84a6.57,6.57,0,0,0-8.91,2.61L1163,1595a6.57,6.57,0,0,0,2.61,8.91l4.89,2.68a6.57,6.57,0,0,0,8.91-2.61l14.9-27.22a2.11,2.11,0,1,1,3.71,2L1183.11,1606A10.79,10.79,0,0,1,1168.47,1610.32Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#afcdfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.63,1653.38l-8.76-4.79c-8.13-4.46-10.87-15.17-6.1-23.89l33.76-61.65a2.11,2.11,0,1,1,3.71,2l-33.76,61.65c-3.66,6.67-1.67,14.82,4.42,18.15l8.76,4.8c6.09,3.34,14,.62,17.68-6l38.45-70.23c3.66-6.67,1.67-14.82-4.42-18.15a2.11,2.11,0,0,1,2-3.71c8.13,4.46,10.87,15.17,6.1,23.89L1171,1645.66C1166.27,1654.37,1155.77,1657.84,1147.63,1653.38Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#afcdfb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 611.73,
    y: 120,
    width: 1171.24,
    height: 998.42,
    rx: 47.87,
    fill: "#dff1fb",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M647.47,120H1747.23A35.74,35.74,0,0,1,1783,155.74v75a0,0,0,0,1,0,0H611.73a0,0,0,0,1,0,0v-75A35.74,35.74,0,0,1,647.47,120Z",
    fill: "#699dee"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M915.68,438.55a13.25,13.25,0,1,1,13.25,13.24A13.25,13.25,0,0,1,915.68,438.55Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#dde7fe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M971.28,438.55a13.25,13.25,0,1,1,13.24,13.24A13.25,13.25,0,0,1,971.28,438.55Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#dde7fe"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.87,438.55a13.25,13.25,0,1,1,13.24,13.24A13.25,13.25,0,0,1,1026.87,438.55Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#dde7fe"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 704.55,
    y: 318.7,
    width: 332.01,
    height: 332.01,
    fill: "#cde0fb",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.51,607.26H1383.42a12.54,12.54,0,0,1-12.55-12.54h0a12.55,12.55,0,0,1,12.55-12.55h264.09a12.54,12.54,0,0,1,12.54,12.55h0A12.53,12.53,0,0,1,1647.51,607.26Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#7c9af2",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1963.3,590.43H1699.22a12.54,12.54,0,0,1-12.55-12.54h0a12.55,12.55,0,0,1,12.55-12.55H1963.3a12.55,12.55,0,0,1,12.55,12.55h0A12.54,12.54,0,0,1,1963.3,590.43Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#7c9af2",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1699.78,703.85H1379a8.13,8.13,0,0,1-8.14-8.13h0a8.13,8.13,0,0,1,8.14-8.13h320.77a8.13,8.13,0,0,1,8.13,8.13h0A8.13,8.13,0,0,1,1699.78,703.85Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.73,703.85h-84.68a8.13,8.13,0,0,1-8.13-8.13h0a8.13,8.13,0,0,1,8.13-8.13h84.68a8.13,8.13,0,0,1,8.13,8.13h0A8.13,8.13,0,0,1,1821.73,703.85Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500,754.29H1379a8.13,8.13,0,0,1-8.14-8.13h0A8.13,8.13,0,0,1,1379,738h121a8.13,8.13,0,0,1,8.13,8.13h0A8.13,8.13,0,0,1,1500,754.29Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.08,754.29H1530.23a8.13,8.13,0,0,1-8.13-8.13h0a8.13,8.13,0,0,1,8.13-8.13h165.85a8.13,8.13,0,0,1,8.13,8.13h0A8.13,8.13,0,0,1,1696.08,754.29Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.73,754.29h-84.68a8.13,8.13,0,0,1-8.13-8.13h0a8.13,8.13,0,0,1,8.13-8.13h84.68a8.13,8.13,0,0,1,8.13,8.13h0A8.13,8.13,0,0,1,1821.73,754.29Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.23,797.9H1379a8.13,8.13,0,0,1-8.14-8.13h0a8.13,8.13,0,0,1,8.14-8.13h164.22a8.13,8.13,0,0,1,8.14,8.13h0A8.13,8.13,0,0,1,1543.23,797.9Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1856.84,797.9h-268.6a8.13,8.13,0,0,1-8.13-8.13h0a8.13,8.13,0,0,1,8.13-8.13h268.6a8.13,8.13,0,0,1,8.13,8.13h0A8.13,8.13,0,0,1,1856.84,797.9Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1699.78,864.09H1379a8.14,8.14,0,0,1-8.14-8.14h0a8.13,8.13,0,0,1,8.14-8.13h320.77a8.13,8.13,0,0,1,8.13,8.13h0A8.14,8.14,0,0,1,1699.78,864.09Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.73,864.09h-84.68a8.14,8.14,0,0,1-8.13-8.14h0a8.13,8.13,0,0,1,8.13-8.13h84.68a8.13,8.13,0,0,1,8.13,8.13h0A8.14,8.14,0,0,1,1821.73,864.09Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500,914.52H1379a8.13,8.13,0,0,1-8.14-8.13h0a8.13,8.13,0,0,1,8.14-8.13h121a8.13,8.13,0,0,1,8.13,8.13h0A8.13,8.13,0,0,1,1500,914.52Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.08,914.52H1530.23a8.13,8.13,0,0,1-8.13-8.13h0a8.13,8.13,0,0,1,8.13-8.13h165.85a8.13,8.13,0,0,1,8.13,8.13h0A8.13,8.13,0,0,1,1696.08,914.52Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1110,632h34.29l92.63,212h-39.1l-21.35-50.83h-99.56l-21.65,50.83h-37.9Zm52.93,128.42-36.39-84.21-36.09,84.21Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 704.55,
    y: 717.59,
    width: 185.46,
    height: 35.8,
    fill: "#f99746"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 704.55,
    y: 753.39,
    width: 185.46,
    height: 35.8,
    fill: "#ed7d2b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 704.55,
    y: 789.19,
    width: 185.46,
    height: 35.8,
    fill: "#474fea"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1283.25,1001.67h-102a7.74,7.74,0,0,1-7.74-7.73h0a7.74,7.74,0,0,1,7.74-7.73h102a7.73,7.73,0,0,1,7.73,7.73h0A7.73,7.73,0,0,1,1283.25,1001.67Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.87,1028.92h-67.66a7.74,7.74,0,0,1-7.74-7.73h0a7.74,7.74,0,0,1,7.74-7.73h67.66a7.73,7.73,0,0,1,7.73,7.73h0A7.73,7.73,0,0,1,1248.87,1028.92Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 704.55,
    y: 902.71,
    width: 185.46,
    height: 73.16,
    fill: "#f99746"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 704.55,
    y: 957.8,
    width: 185.46,
    height: 52.32,
    fill: "#b5453c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "704.55 902.71 771.09 958.6 704.55 1010.12 704.55 902.71",
    fill: "#474fea"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1283.25,1186.79h-102a7.74,7.74,0,0,1-7.74-7.73h0a7.74,7.74,0,0,1,7.74-7.73h102a7.73,7.73,0,0,1,7.73,7.73h0A7.73,7.73,0,0,1,1283.25,1186.79Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.87,1214.05h-67.66a7.74,7.74,0,0,1-7.74-7.73h0a7.75,7.75,0,0,1,7.74-7.74h67.66a7.74,7.74,0,0,1,7.73,7.74h0A7.73,7.73,0,0,1,1248.87,1214.05Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#bdd1f9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2051.38,474.24s4.83,57.56-8.28,56.69-39-26.21-91.27-22.09S1835.63,524.39,1797,456s49.43-88.08,49.43-88.08l205,106.32Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1683.71 206.21 1947.03 227.86 1952.51 216.15 1700.05 29.79 1445.04 0 1440.14 10.48 1683.71 206.21 1683.71 206.21",
    fill: "#2b478b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2119.5,668.33a10.21,10.21,0,1,0-7,12.63,10.22,10.22,0,0,0,7-12.63Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f99746"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2110.72,671.16c10.56-.82,13,95.28,13,95.28s-6.89,3.24-10.27,2.48-5.12-13.74-5.12-13.74l-.32,13.61s-11.59.4-15.6-2.42c0,0,1.57-93.9,18.28-95.21Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f99746"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "1857.58 409.51 1855.67 199.56 1854.3 198.54 1716.76 96.79 1711.82 103.48 1847.99 204.21 1851.07 409.15 1857.58 409.51",
    fill: "#f99746"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1456.55,1180.27H2037a84.94,84.94,0,0,1,84.94,84.94v48a86.87,86.87,0,0,1-86.87,86.87H1456.55a0,0,0,0,1,0,0V1180.27A0,0,0,0,1,1456.55,1180.27Z",
    fill: "#fcecdb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2874.73,1534.52v33.06a100.93,100.93,0,0,1-12.2,48.44c-15.59,28.62-44.58,47.85-77.77,47.85H1695.32c-7.21,0-13-6.25-13-13.95v-5c0-7.71,5.84-14,13-14h664.11a90.7,90.7,0,0,0,9.32-15,94.39,94.39,0,0,0,9.74-42v-42a93.35,93.35,0,0,0-2.69-22.37,90.37,90.37,0,0,0-15.4-32.64H1695.32c-7.21,0-13-6.25-13-14v-4.94c0-7.71,5.84-14,13-14H2790.25c38.58,0,71.12,27.68,81.22,65.51A95.87,95.87,0,0,1,2874.73,1534.52Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#699dee"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2871.47,1509.6H2375.8a90.37,90.37,0,0,0-15.4-32.64H1695.32c-7.21,0-13-6.25-13-14v-4.94c0-7.71,5.84-14,13-14H2790.25C2828.83,1444.09,2861.37,1471.77,2871.47,1509.6Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#548ee2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "1456.55 1290.17 1537.21 1293.86 1456.55 1296.09 1456.55 1290.17",
    fill: "#f4d2b8"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "1456.55 1324.65 1648.46 1328.35 1456.55 1330.57 1456.55 1324.65",
    fill: "#f4d2b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1546.57,1663.42h567.87a82,82,0,0,1,82,82v11.88a77,77,0,0,1-77,77H1546.57a0,0,0,0,1,0,0v-171A0,0,0,0,1,1546.57,1663.42Z",
    transform: "translate(3486.46 3233.98) rotate(180)",
    fill: "#f99746"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2089,1663.42h647.21a80.1,80.1,0,0,1,80.1,80.1V1756a78.33,78.33,0,0,1-78.33,78.33H2089a0,0,0,0,1,0,0v-171A0,0,0,0,1,2089,1663.42Z",
    transform: "translate(4648.76 3233.98) rotate(180)",
    fill: "#fcecdb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2034.36,
    y: 1808.81,
    width: 815.71,
    height: 25.57,
    rx: 11.9,
    transform: "translate(4627.85 3379.36) rotate(180)",
    fill: "#f99746"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2034.36,
    y: 1663.42,
    width: 815.71,
    height: 25.57,
    rx: 11.9,
    transform: "translate(4627.85 3088.59) rotate(180)",
    fill: "#f99746"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "2559.75 1485.08 2471.57 1487.95 2559.75 1489.68 2559.75 1485.08",
    fill: "#f4d2b8"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "2559.75 1445.74 2349.96 1448.61 2559.75 1450.34 2559.75 1445.74",
    fill: "#f4d2b8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2608.71,1711.85a39.73,39.73,0,0,1,12,19.42,32.23,32.23,0,0,1,.93,6.76c.5,16,0,52.35,0,52.35l26.54-18.16,26.47,18.16v-49.21c0-9.31-2.27-18.36-6.49-24.28-2-2.88-4.52-5-7.33-5Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#699dee"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2608.71,1711.85a39.73,39.73,0,0,1,12,19.42l53.19.72s-2.09-17.29-13.07-20.14Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#568cdb"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.58,929.56h561a89.81,89.81,0,0,1,89.81,89.81v69.53a91.84,91.84,0,0,1-91.84,91.84H1310.58a0,0,0,0,1,0,0V929.56a0,0,0,0,1,0,0Z",
    fill: "#fcecdb"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2218.25,1290.83v54.06c-.14,23.09-10.84,43.12-26.56,53.83a46.45,46.45,0,0,1-26.2,8.26H1550c-7.21,0-13.06,7-13.06,15.6V1429c0,8.61,5.85,15.59,13.06,15.59h1063.2c30.51,0,57.47-18.11,73.75-45.83a121.82,121.82,0,0,0,16.3-61.71v-42.65a117,117,0,0,0-8.4-43.92c-13.67-33.77-42.63-57.06-76.15-57.06H1550c-7.21,0-13.06,7-13.06,15.59v6.37c0,8.62,5.85,15.6,13.06,15.6h617.33c14.76,0,28.11,7.5,37.44,19.5A66.44,66.44,0,0,1,2218.25,1290.83Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#afcdfb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1537,1422.58V1429c0,8.61,5.85,15.59,13.06,15.59h1063.2c30.51,0,57.47-18.11,73.75-45.83h-495.3a46.45,46.45,0,0,1-26.2,8.26H1550C1542.83,1407,1537,1414,1537,1422.58Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#a4c4f4"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "1310.58 1055.15 1389.48 1059.37 1310.58 1061.91 1310.58 1055.15",
    fill: "#f4d2b8"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "1310.58 997.34 1498.29 1001.57 1310.58 1004.11 1310.58 997.34",
    fill: "#f4d2b8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1752.94,1264.54s-12.39,8-16.49,21.06a27.57,27.57,0,0,0-1.29,7.32c-.68,17.4,0,56.76,0,56.76L1698.59,1330l-36.48,19.68v-53.35c0-10.09,3.13-19.91,8.94-26.33,2.82-3.12,6.24-5.46,10.11-5.46Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f99746"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1752.94,1264.54s-12.39,8-16.49,21.06l-73.29.78s2.87-18.75,18-21.84Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ed7d2b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "girl_2",
    "data-name": "girl 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M818.68,1422.33s114.57,49.92,135.36,49,149-39,149-39l-3.27,22s-98.89,56.88-133.46,60.11c-34,3.17-150.44-30.55-161.67-37.67S786,1429.54,818.68,1422.33Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.47,1238.71s-42.27-8-63.32,7.34C700,1273.9,698,1369.9,683.68,1384.2s-48.74,8.2-51.8,82.2,13.71,80.18-6.28,113.21,8.46,66.09,8.46,66.09-11.65-18.23-6.66-31.39c0,0,4.85,29,23.31,35.85s21.18,11.8,24.13,21.79c0,0,157.42-80.67,157.59-137.89s31-113.89,15.85-138.68c0,0,6.74,10.6,7.57,22.4,0,0,9.07-17.39-6.66-33.58s18.46-49.7,13.4-88.5C859.11,1269.06,840.42,1239.87,801.47,1238.71Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.6,1476.85c-10.06,7-22.68,12.73-38.51,16.39-59.37,13.72-82.13-36.46-90.67-70.91a51.17,51.17,0,0,1,20.11-6.18c4.29-.5,8.81-.84,12.55-1,6.66-5.11,16.6-26,18.79-58.46l2.8.75,46.79,12.81s-2.15,14.87-3.2,28.93c-.81,11-.94,21.52,1.15,24.09,3.65.79,5.84,1.31,5.84,1.31l0,0A301.5,301.5,0,0,1,832.6,1476.85Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.46,1370.24s-2.15,14.86-3.19,28.93c-26.51-2.65-38.82-27.89-43.61-41.74Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.37,1384.2s-62.92-3.47-60.15-42.62-3.5-66,36.79-65.41,47,16,49.29,29.35S828.81,1384.09,812.37,1384.2Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838,1283.62c-8.87-12.48-16.39-10.42-20.76-7.17-33-21.35-57.13,5-57.13,5-6.22,27.79-27.63,42.43-27.63,42.43s10.94,7.89,37.84,3c8.21-1.5,15.83-6.72,22.45-13.23a146.77,146.77,0,0,1-27.45,29c32.59-12.32,48.41-55.28,50-59.83,3.59,3.72,10.62,11.75,12.4,19.25,2.42,10.19,12.85,26.13,18.88,25.86C846.59,1327.92,851.3,1302.32,838,1283.62Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.5,1604.78c-5.69-29-24.21-145.1-5.69-182.45,6.66-13.41,32.77-14.62,61.41-13.45,8.92,5.76,42.88,27.5,56.84,24.79l.78-.18c6.57-1.65,9-6.26,3.57-10.24a124.87,124.87,0,0,1,31.8,2c9.95,1.87,36.8,15.76,36.8,15.76s-13.52,24.42-33.45,32.85c3.39,30.32-1.65,43.69-33.11,113.72C777.88,1646.72,808,1700,808,1700s-156.46,125.8-157.33,61.75C650.06,1713.54,692.76,1641.9,685.5,1604.78Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.8,1836.8a29.06,29.06,0,0,0,20.92-12.74c.76-1.13,1.56-2.35,2.42-3.64,17.81-27,24.74-109.53,64.8-197.49,9.76-21.41,44.78-25.26,54.33-49.47,0,0,23.5-78.46-45-80.78S729.83,1711,728,1734.14C726.26,1756.55,682.73,1851.81,815.8,1836.8Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#dd6d22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088,1835H990.55s-3.64-15.55,2.76-26.13c5.66-9.36,3.49-14.69-.71-22.44a37.86,37.86,0,0,0,16.42,3.09c4.86-.28,10-2.48,14.5-5.1,4.2,4.79,22.17,25.15,27.78,29.18C1057.67,1818.17,1086.08,1816.54,1088,1835Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.5,1515.37c5.87,44,28.79,182.92,69.23,250.69,13,21.85-32.85,34.1-33.09,34-6.16-1.61-16.41-11.42-21.14-15.68C942.67,1754.82,876,1671,876,1603.87c0-32.75-.58-95.31,23.24-111.2C913.93,1482.88,958.17,1497.88,960.5,1515.37Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.66,1835s3.61-5,9.91-14.57c7.5-11.36,15.8-33.71,25.86-62.36C804,1728,816.55,1691,832.23,1652.5c4.84-11.89,10-23.92,15.44-35.92,9.76-21.42,36.6-18.46,46.15-42.67,0,0,37.26-83.92-31.23-86.23s-198.66,224.49-206.14,246.46C648.26,1758.18,608.31,1858,757.66,1835Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.48,1835H919s-3.64-15.55,2.76-26.13c5.67-9.36,3.49-14.69-.7-22.44a37.83,37.83,0,0,0,16.42,3.09c4.86-.28,10-2.48,14.5-5.1,4.19,4.79,22.16,25.15,27.77,29.18C986.1,1818.17,1014.51,1816.54,1016.48,1835Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.43,1758.06C804,1728,816.55,1691,832.23,1652.5c-4.09-29.17-12.92-54.69-27.78-65C804.45,1587.53,768.43,1699.14,793.43,1758.06Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.59,1512.25c5.87,44,14.14,186,54.58,253.81,13,21.85-32.85,34.1-33.1,34-6.15-1.61-16.41-11.42-21.13-15.68-32.83-29.59-99.48-113.37-99.48-180.54,0-32.75,38.44-92.68,62.25-108.58C881.38,1485.5,901.26,1494.76,903.59,1512.25Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.15,1361.68s-5.95-2.35-22.68-1c0,0,.89,6.53,13.23,7.17C821.69,1368.23,824.15,1361.68,824.15,1361.68Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "858.63 1122.38 838.42 1085.91 794.69 1207.92 820.49 1235.62 858.63 1122.38",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "753.09 1143.74 712.44 1259.85 820.49 1235.62 858.63 1122.38 753.09 1143.74",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "714.6 1253.99 712.71 1250.68 751.17 1140.8 753.09 1143.74 714.6 1253.99",
    fill: "#efdece"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "751.17 1140.8 853.6 1120.87 858.63 1122.38 753.09 1143.74 751.17 1140.8",
    fill: "#fcecdb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "858.63 1122.38 836.77 1087.68 822.84 1126.85 853.6 1120.87 858.63 1122.38",
    fill: "#efdece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.87,1424.37c-3.51-.68-11-3.52-18.68-5.62,2.28-1.77,4.81-3.94,5.52-6.17,1.36-4.3,2.27-5.69-2.27-4.33s-20.42,8.65-20.42,8.65l0,0c-9,2.63-17.33,15.39-17.33,15.39S876,1471.57,862.59,1472.25c-20.8,1-159.17-49.92-159.17-49.92-32.66,7.21-25.33,47.34-14.09,54.46s110.8,43.34,169.81,44c29.89.35,138.61-69.53,138.61-69.53s12.71-5.81,22.7-4,33.13,0,38.12-8.17S1046.77,1425.5,1040.87,1424.37Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.71,1447.46s-12.37,39.18-54.88,48.1c0,0-70.19-21.63-35.24-69.44C684.59,1426.12,719.14,1400.44,774.71,1447.46Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.4,1427.32h0a11,11,0,0,0-.37-3.18s-10-15.84-13.3-16.49c-10-2-10,11.18-7.86,19.67a34.42,34.42,0,0,0,8.26,14.64h0l-.4,12.39C1116.6,1445.08,1113.4,1427.32,1113.4,1427.32Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2222.2,924.14c3.65-90.28-72-130.39-149.39-130.39s-161.57,20-168.87,140.1c-4.69,77.23,36.48,124.75,155,124.75,40,0,71.05-6.31,94.85-17.56l59.26,52.66L2184,1020.92C2209.76,996.93,2220.63,963.1,2222.2,924.14Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#91b5f8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2198.12,1400.48c18.36,32.48,41.65,45.14,41.65,45.14l97.27.68S2184.11,1375.7,2198.12,1400.48Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2271.06,1651.32c2.51,2.92,2.81,6.17,1.53,9.63l0,0c-2.37,6.39-10.08,13.5-19,20.58-1.14.91-2.16,1.74-3,2.51l-.69.6-.53.47c-8.35,7.6-5.24,9.37-20.26,24.8-17.14,17.57-28.85,17.81-32.17,16.17-2.8-1.39,3-10.74,9.41-21.24.31-.51.61-1,.93-1.53.86-1.4,1.7-2.82,2.55-4.22,7.53-12.64,5.66-18.61,4-37.52-1.32-15.36-23.28-85.93-23.28-85.93l32.63-5.39s9.42,56.14,20.17,64.86c5.75,4.64,12.23,4.74,17.76,8.19.39.24.77.49,1.15.74A43,43,0,0,1,2271.06,1651.32Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2271.06,1651.32c2.51,2.92,2.81,6.17,1.53,9.63l0,0c-2.89,6.38-10.41,13.45-19.07,20.52-1.13.92-2.13,1.77-3,2.57l-.69.6-.53.47c-8.35,7.6-5.24,9.37-20.26,24.8-17.14,17.57-28.85,17.81-32.17,16.17-2.8-1.39,3-10.74,9.41-21.24a72.5,72.5,0,0,0,30.47-22.12c10.33-13,17.28-29.74,24.32-39.42.39.24.77.49,1.15.74A43,43,0,0,1,2271.06,1651.32Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2008.41,1629.11c-2.08,10.05-16.41,8.27-32.4,4.24s-12.22.65-35-2-29.63-11.24-30.3-14.63c-.6-3,10.67-4,22.76-5.3,1.53-.16,3-.34,4.58-.52,13.66-1.61,23.71-10.35,36.15-17.49,11.79-6.76,29.51-34.54,29.51-34.54l31.25,2.69s-16.59,24.81-23,35.6c-3.78,6.35-3.64,14.78-3.22,21.29A39.91,39.91,0,0,1,2008.41,1629.11Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1976,1633.35c-16-4-12.22.65-35-2s-29.63-11.24-30.3-14.63c-.6-3,10.67-4,22.76-5.3l.12.23a64.27,64.27,0,0,0,32.58,10.38c15.46.49,31.88-3.83,42.56-3.58a39.91,39.91,0,0,1-.32,10.69C2006.33,1639.16,1992,1637.38,1976,1633.35Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2129.66,1430l28.67,78.86,37.44,103a61.93,61.93,0,0,0,20.29-1.71c9.15-2.57,19.67-9.4,19.67-9.4s-9.82-110.35-29.14-173.79c-5-16.29-10.53-29.47-16.75-36.91C2159.45,1353.61,2129.66,1430,2129.66,1430Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2160.26,1305.31c19.19-6,73.75,2.27,128.54,13.4l11.63-18.86,118.57-8.42s38.49,87,16.7,142.1c-3.21,8.1-11,11.47-21.68,11.57h0s-70.73,1.23-93.64,1.07c-58.93-.42-124.44-41.39-132.94-43.16-13.91-2.88-19.68,24.94-33.82,54.1s-131.86,128.63-131.86,128.63-18,.06-25.4-2.78c-8-3.06-10.86-7-10.86-7S2117,1318.94,2160.26,1305.31Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#2b478b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2302.27,1136.65c42,23.53,127.31,72.3,127.76,72,0,0,31.38,12.08,49.32.35,29.89-19.55,46.22-72.62-7.87-118.77-27-23-46.22-28.71-48.89-65.18-1.45-19.78-28-85.23-73-79.51a69.17,69.17,0,0,1-11.32.67,42,42,0,0,0-22.83,5.72C2290,966.88,2239.07,1127.21,2302.27,1136.65Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2337.78,1117.12c-.18.12,20.72,7.42,34.77,1.31,13.22-5.73,23.35-27.34,23.16-27.35-6-.32-12.54-5.61-17.36-40l-2.56.9-43,15.14s3,13.8,4.93,26.92C2339.3,1105,2340.14,1115.58,2337.78,1117.12Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2332.76,1067.08s1.83,9.67,4.38,23.49c24.68-4.27,35.08-25.32,38.65-38.63Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ed975d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2326.27,1080.71s58.78-7.47,53.56-44-1.14-62.1-38.88-58.88-43,18.2-44.27,30.82S2310.84,1081.71,2326.27,1080.71Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2299,988.66s37.36,32.66,62.91,35.45,35.29-5.35,35.29-5.35a99.92,99.92,0,0,1-23.91-32.87,18,18,0,0,0-14.75-10.71C2340.26,973.48,2305.66,972.51,2299,988.66Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2322.49,985.92S2309.82,998,2305.8,1007c-3.88,8.67-5.18,29.48-2.19,37.77,0,0-19.33-38.24-8.1-56.67C2307.41,968.54,2322.49,985.92,2322.49,985.92Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2287.73,1203.27c.93,118.88-.18,94,12.74,105.41,3.12,2.74,11.91,4.42,23.5,5.26,36.43,2.68,100.55-2.87,103-9.59,8.58-23.25,2.69-30.53,10-66.17.75-3.79,1.69-7.89,2.78-12.35,6-24.47,11.78-32.77-8.7-72.29-18.56-35.8-37.9-64.88-39.67-63.85-49.85,29.12-53.68,4.32-53.68,4.32S2287.26,1145.29,2287.73,1203.27Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f9ddbf"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2158.33,1508.88l37.44,103a61.93,61.93,0,0,0,20.29-1.71c9.15-2.57,19.67-9.4,19.67-9.4s-9.82-110.35-29.14-173.79Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#2b478b"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2337.69,1094s-51.14,8.3-57.3,30.25-42.36,151-42.36,151,25.93,4.85,38-7.06,42.53-111,42.53-111Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f9ddbf"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2324,1313.94c36.43,2.68,100.55-2.87,103-9.59,8.58-23.25,2.69-30.53,10-66.17l-17.23-49.63s2.51,55.15-13.85,69.54-66.76,27.52-74.74,39.58C2327.28,1303.45,2324.73,1309.27,2324,1313.94Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f2ccaa"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2365.9,1291.05s-35.91-8.26-41.73-5.11-20.09,14.67-21.89,18.71,12.94-3,17.72-4.23c3.11-.81,11.23,2.08,15.26,3.45,16.93,5.78,27.35,2.94,27.35,2.94Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2391.4,1089.66s48.26,3.32,64.81,26.75c23.3,33,69,173.17,42.11,191.63-30.27,20.8-137.15,4.53-137.15,4.53s-3.44-16.66,1.57-24.68,85.6-20.45,89.34-24.14-45.93-72.77-45.85-83.91S2391.4,1089.66,2391.4,1089.66Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f9ddbf"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2322.36,1295.94s-7.61,9.66-10.08,10.81a7.41,7.41,0,0,1-4.08.84l5.15-9.1Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2324.17,1285.94l-22,10.49s.92,1.53,3.62,1.42,9.52-2.54,9.52-2.54Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "2060.38 1058.62 1887.09 1057.4 1835.88 927.4 2008.9 928.63 2060.38 1058.62",
    fill: "#f99746"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "1885.1 1052.33 2113.92 1053.95 2113.88 1059 1887.09 1057.4 1885.1 1052.33",
    fill: "#ed7d2b"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2187.88,1256.71c-1.28-4.57,1.39-8.24,5.94-8.21s9.29,3.76,10.56,8.32-1.39,8.25-5.94,8.21S2189.15,1261.27,2187.88,1256.71Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1474.77,
    y: 1520.61,
    width: 104.67,
    height: 526.5,
    transform: "translate(-513.64 3046.8) rotate(-89.99)",
    fill: "#c65447"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.84,1836.15l-77.38-33.1-45-19.26,46.06-19.68,76.35-32.63s10.19,25.48,10.34,49.45C1274.45,1818.54,1263.84,1836.15,1263.84,1836.15Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#fcecdb"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1851.56,1766.31v33.09a36.86,36.86,0,0,1-36.86,36.85h-24.36l0-104.67h26.49A34.71,34.71,0,0,1,1851.56,1766.31Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#fcecdb"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.52,1764.11c1.92,10.57,3.58,26.77-1.06,38.94l-45-19.26Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#2b478b"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1377,1186.52s9.43,40.92,36.92,40.92c23.57,0,55.89-53.27,55.89-53.27Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f99746"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1692.65,1790.91,1675,1803.06s-84.94-90.54-105.45-177.33c-3.65-15.49-5.13-30.77-3.57-45.27,0,0-1.24-3.93-3.41-10.88-.09-.31-.19-.62-.29-.93-1-3.05-2.08-6.64-3.35-10.7-4.12-13.11-9.78-31.06-16.22-51.49-14.85-47-48.8-153-63.31-197.16l104.28-37.73s11.85,27,28.87,100.42c2.62,9.58,5.24,20.18,7.7,31.72,2.78,13.08,5.37,27.38,7.53,42.83a656.64,656.64,0,0,1,6.25,87.9c.06,13.13-.26,26.76-1,40.81-.57,10.3,1,24,3.84,39.66C1650,1686.33,1692.65,1790.91,1692.65,1790.91Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#2b478b"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1748.21,1834.54H1663.9s-3.15-13.44,2.38-22.59c4.9-8.1,3-12.71-.6-19.41a32.68,32.68,0,0,0,14.2,2.67c4.2-.24,8.64-2.14,12.54-4.41,3.62,4.14,19.16,21.75,24,25.24C1722,1820,1746.51,1818.59,1748.21,1834.54Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1627.77,1446.54l-65.5,122.11c-1-3.05-2.08-6.64-3.35-10.7-4.12-13.11-9.78-31.06-16.22-51.49-14.85-47-48.8-153-63.31-197.16l104.28-37.73s11.85,27,28.87,100.42c2.62,9.58,5.24,20.18,7.7,31.72C1623,1416.79,1625.61,1431.09,1627.77,1446.54Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.69,1808.15s-5.83,14.32-.34,26.39h45.86s1-10.88-15.69-23.51C1494.92,1801.47,1477.69,1808.15,1477.69,1808.15Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#233862"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1527.6,876c0-2.29,1.2-26.9,38.6-29.09,0,0-18.35,2.64-21.34,10.81,0,0,12.29-10.3,22.57-7.33s16.71,20.7,16.92,26.58-5,25-11.45,26.75a19.9,19.9,0,0,1-7.85.2,86.59,86.59,0,0,1,5.24,8.85c15.68,30.3,2.16,66-10.57,63-8.16-1.93-13.12,12.22-13.12,12.22l-78.48-67.49S1495.62,859.9,1527.6,876Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#2c3a64"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1478.27,1081.05c8.7,6,19.61,11,33.3,14.18,51.34,11.86,71-31.53,78.41-61.32a44.15,44.15,0,0,0-17.39-5.34c-3.71-.44-7.62-.73-10.85-.89-5.76-4.41-14.36-22.49-16.25-50.55l-2.42.65-40.46,11.08s1.85,12.86,2.76,25c.7,9.51.81,18.6-1,20.83-3.16.68-5.05,1.13-5.05,1.13l0,0A259.94,259.94,0,0,0,1478.27,1081.05Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1502.61,988.86s1.86,12.85,2.76,25c22.92-2.29,33.56-24.12,37.7-36.09Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ed985f"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1502.14,1008.17s52.77-13.57,43.82-46.3-8.17-56.54-42.24-49.27-37.18,21.55-36.85,33.21S1488.18,1010.85,1502.14,1008.17Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1463.43,927.18c5.42-12.07,12.15-11.6,16.4-9.58,24.38-23.68,49.3-5.42,49.3-5.42,10,22.52,30.59,31.32,30.59,31.32s-8,8.55-31.59,8.93c-7.22.12-14.55-3-21.27-7.43A127.07,127.07,0,0,0,1535,965c-29.72-5-50.38-38.72-52.5-42.31-2.41,3.76-7,11.76-7.26,18.42-.33,9,3.2,26.53-2,27.32C1473.31,968.41,1455.31,945.29,1463.43,927.18Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#2c3a64"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1487,1033.11s88.64-21.52,127.18,10.27L1594.88,1312l-173.36-41.89s4.88-17,38.12-62.19S1478.42,1096.43,1487,1033.11Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1538.63,1282.11s-.1.91-.28,2.65c-.08.74-.18,1.65-.29,2.7-.75,7-2.16,20.32-4,37.69-4.76,45.56-12.22,118.73-17.31,176.49-4,45.16-6.51,80.9-5.14,86.64,4.1,17.27,0,223.71,0,223.71-14.74,7.07-37.08,0-37.08,0s-39.24-186-33.75-211.89-3.67-47.93-3.67-47.93C1406.65,1410.26,1410,1331.6,1416,1294a159,159,0,0,1,5.21-23,49.16,49.16,0,0,1,2.09-5.65C1490.56,1247.22,1538.63,1282.11,1538.63,1282.11Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#2b478b"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1626.09,1120c-4.28,32.32-21.4,71.87-27.51,93.15,0,0,10.22,73.91.46,94.2-1.11,2.31-2.48,3.93-4.16,4.66-36.15,15.75-176.92.46-182.86-45-2.16-16.5,53.62-74.54,56.87-81.58,1.35-2.92,2.78-12.36-3.76-31.93-9.27,28.58-60.43,20.36-60.43,20.36,6-10.27,21-81.36,37.67-113.45,12.56-24.12,46.09-27.61,46.09-27.61s14,22.13,47.71,19,39.93-23.8,39.93-23.8,29.93,4,39.16,11.42C1616.86,1040.75,1631.7,1077.66,1626.09,1120Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f99746"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1598.58,1213.15s10.22,73.91.46,94.2c-26.33-13.22-47.09-49-42.3-88.82,3.54-29.44,8.81-36.16,24.56-53,11.58-12.38,38.34-13.08,36.24-7.19C1611.3,1175.87,1601.81,1201.91,1598.58,1213.15Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ed7d2b"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "1232.06 861.94 1292.41 958.78 1189.71 958.78 1132.2 864.04 1232.06 861.94",
    fill: "#1c468a"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "1289.28 953.91 1290.32 950.53 1233.2 858.89 1232.06 861.94 1289.28 953.91",
    fill: "#efdece"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "1233.2 858.89 1136.45 861.65 1132.2 864.04 1232.06 861.94 1233.2 858.89",
    fill: "#fcecdb"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "1132.2 864.04 1077.93 834.66 1141.19 934.01 1189.71 958.78 1132.2 864.04",
    fill: "#163560"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1676,1195.71c-5.81,2.66-20.73,20.23-26.06,22-24,8-125.87-13.31-125.87-13.31l3.16-17.85s100,2.65,111-.29c2.07-.56,12.88-17.46,17-19.89Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1527.24,1186.56s-12.06-9.81-20.21-7.59-20.15,12.53-24.6,15-16.55,11.17-10.42,16.45,25.22.74,32.79-3.3,19.29-2.67,19.29-2.67Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1509.34,1178.65s-14.66-1.75-18.67-1.67-2.91,1-.7,4.06,9.84,4.3,10.19,5.39S1509.34,1178.65,1509.34,1178.65Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1576.1,1028s43.48,5.16,55.45,23.8c15.13,23.58,50.85,117.46,49.7,141.12,0,0-26.12,44.45-115.67,37.33,0,0-9.32-32.91,9.52-43.77,0,0,46-8.18,51.29-12.85l-37.5-68.15Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#f99746"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1402.7,1163.25c-1.35-5.48-13.29-2.06-17.32,1.1a16.24,16.24,0,0,0-3.06,3.59c-.13-.91-.23-1.79-.3-2.47-.22-2.58-3.22-7.19-4-3.74s-2,18-2,18c-.15,11.68,7.36,16.5,12.18,12.7S1404,1168.73,1402.7,1163.25Z",
    transform: "translate(-256.59 -263.81)",
    fill: "#ffb27d"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 1570.69,
    width: 2745.48,
    height: 9.37,
    rx: 3.53,
    fill: "#2e3552"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStuTeaLogin);
export default __webpack_public_path__ + "static/media/StuTea-Login.2805ce263d8aec6f13e135d5a36c584a.svg";
export { ForwardRef as ReactComponent };